<template>
  <div class="flight-page">
    <div class="flight-ul">
      <div class="flight-li" v-for="(item, index) in waiting_flight_list">
        <div class="flight-head">
          <div class="head-left">
            <span></span>
            {{ item.flgtno }}
          </div>
          <div class="head-right">
            <div class="time">
              <img src="@/assets/images/larg/ic2.png" />{{ item.tkofarpt }} {{ item.lanchTimeFormat }}
            </div>
            <span>\</span>
            <div class="time">
              <img src="@/assets/images/larg/ic1.png" />{{ item.arvlarpt }} {{ item.fallTimeFormat }}
            </div>
          </div>
        </div>
        <div class="flight-box">
          <div class="flight-left">
            <div class="left-li">
              <div class="left-laber">计划起飞时间</div>
              <div class="left-data active">{{ item.lanchTimeFormat }}</div>
            </div>
            <div class="left-li">
              <div class="left-laber">机尾号</div>
              <div class="left-data">{{ item.aircraft }}</div>
            </div>
            <div class="left-li">
              <div class="left-laber">机型</div>
              <div class="left-data">{{ item.acftmodl }}</div>
            </div>
          </div>
          <div class="flight-right">
            <echarts1 ref="chart4" chartWidth="100%" chartHeight="100px" :severe="item.severe_bump" :moderate="item.moderate_bump"></echarts1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts1 from "@/views/largescreen/components/echarts1";

import { flightBump } from "@/api/bump";
import {pageParsePlanAboutToVO} from "@/api/api";
export default {
  name: "flight",
  components: { echarts1 },
  data() {
    return {
      waiting_flight_list: [] //即将起飞的航班列表
    };
  },
  mounted() {
    //获取航班列表
    this.queryFlightList();
    window.addEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      if (this.$refs.chart4) {
        this.$refs.chart4.size()
      }
    },
    /***************获取航班列表******************/
    async queryFlightList() {
      const result = await pageParsePlanAboutToVO();
      // console.log(['queryFlightList', result])
      if (result.code === "A00000") {
        var flight_list = result.data;
        if (flight_list.length <= 0) {
          this.loading = false;

          return false;
        }

        let promises = flight_list.map(async (item) => {
          item.triptime = this.common.ForamtTime(item.triptime, 2);
        });

        for (const promise of promises) {
          await promise;
        }
        flight_list = await this.getFlightBumpStatus(flight_list);
        this.waiting_flight_list = [
          ...this.waiting_flight_list,
          ...flight_list,
        ];
        // console.log(this.waiting_flight_list, "即将起飞的航班信息");
      } else {
        this.$message.error(result.message);
        return false;
      }
    },

    //获取每个航班近几天的颠簸统计情况
    async getFlightBumpStatus(flight_list) {
      //获取航班航班号集合
      var flight = [];
      flight_list.forEach((item) => {
        flight.push(item.flgtno);
      });

      //获取过去7天的日期集合
      var dateList = this.common.getDateList(new Date());

      // return false;
      const param = {};
      param.fltNums = flight;
      param.startDay = dateList[0];
      param.endDay = dateList[dateList.length - 1];
      const result = await flightBump(param);
      var flight_bump = [];
      if (result.code === "A00000") {
        // console.log(result.data,'457575758njhnihiohoi')
        if (result.data.length > 0) {
          var list = result.data;
          //遍历各个航班的颠簸统计
          list.forEach((item, index) => {
            //遍历不同日期的颠簸数据
            var severe_bump = []; //重度颠簸集合
            var moderate_bump = []; //中度颠簸集合
            if (item.bumpList.length > 0) {
              item.bumpList.forEach((val, key) => {
                severe_bump.push(val.severeTime);
                moderate_bump.push(val.moderateTime);
              });
            }
            flight_bump[item.fltNum] = {};
            flight_bump[item.fltNum].severe_bump = severe_bump;
            flight_bump[item.fltNum].moderate_bump = moderate_bump;
          });
        }
      }

      //
      flight_list.forEach((item) => {
        if (flight_bump[item.flgtno]) {
          var bump_info = flight_bump[item.flgtno];
          item.severe_bump = bump_info.severe_bump;
          item.moderate_bump = bump_info.moderate_bump;
        } else {
          item.severe_bump = [0, 0, 0, 0, 0, 0, 0];
          item.moderate_bump = [0, 0, 0, 0, 0, 0, 0];
        }
      });
      return flight_list;
    },
  },
};
</script>

<style lang="less" scoped>
.flight-ul {
  height: 520px;
  overflow: auto;
  margin-top: 30px;
  border-bottom: 1px solid #324467;
  .flight-li {
    .flight-head {
      display: flex;
      align-items: center;
      background: #293752;
      height: 28px;
      padding: 0 8px;
      justify-content: space-between;
      .head-left {
        font-size: 18px;
        display: flex;
        align-items: center;
        span {
          width: 8px;
          margin-right: 8px;
          height: 8px;
          border: 1px solid #c2d9f5;
        }
      }
      .head-right {
        display: flex;
        align-items: center;
        .time {
          color: #c2d9f5;
          display: flex;
          align-items: center;
          font-size: 14px;
          img {
            width: 14px;
            margin-right: 8px;
          }
        }
        span {
          margin: 0 8px;
        }
      }
    }
    .flight-box {
      padding-bottom: 6px;
      display: flex;
      .flight-left {
        width: 158px;
        .left-li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 16px;
          .left-laber {
            color: #c2d9f5;
            font-size: 12px;
            text-align: left;
            margin-right: 16px;
          }
          .left-data.active {
            color: #f3b571;
          }
          .left-data {
            color: #aaf688;
            font-size: 14px;
          }
        }
      }
      .flight-right {
        flex: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/largescreen/components/flight.vue